import React from "react";
import { usePermissions } from "./PermissionContext";
import { useModule } from "./ModuleContext";

const AdditionalPermissionWrapper = ({ permissionKey, moduleId, children, fallback = null }) => {
  const { activeModuleId } = useModule();
  const { hasAdditionalPermission } = usePermissions();

  const targetModuleId = moduleId || activeModuleId;
  console.log("targetModuleId", targetModuleId);
  const isAllowed = hasAdditionalPermission(targetModuleId, permissionKey);

  return isAllowed ? children : fallback;
};

export default AdditionalPermissionWrapper;
